/** @module Image */

/**
 * Determines if the given image URL leads to a valid image
 *
 * @param {String} imageUrl the URL to the image
 *
 * @returns {Promise<boolean>} whether the image exists or not;
 */
export function imageExists(imageUrl) {
    return new Promise(resolve => {
        const image = new Image();

        image.addEventListener('load', () => resolve(true));
        image.addEventListener('error', () => resolve(false));

        image.src = imageUrl;
    });
}

/**
 * Creates an empty placeholder image with specified dimensions
 *
 * @param {number} width
 * @param {number} height
 * @returns {HTMLImageElement}
 */
export function createTransparentImage(width = 100, height = 100, type = 'image/png') {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').clearRect(0, 0, width, height);

    const image = new Image();
    image.width = width;
    image.height = height;
    image.src = canvas.toDataURL(type);

    return image;
}
